import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo, {"container":"body","duration":500,"easing":"ease","offset":0,"force":true,"cancelable":true,"onStart":false,"onDone":false,"onCancel":false,"x":false,"y":true})

export default function (ctx, inject) {
    inject('scrollTo', VueScrollTo.scrollTo)
}
